import { Label } from '@fluentui/react';
import React from 'react';
import { IPFieldProps } from '../../types/field-props';
import CLabel from '../types/CLabel';

export const UXLabel = (props: IPFieldProps<CLabel>): JSX.Element => {
    return <>
        {(props.field.label ?? '').split('\n').map((x, i) => <Label style={{ fontWeight: 400 }} key={i}>{x}</Label>)}
    </>
}